import { createStore } from 'vuex'

export default createStore({
  state: {
    imageModal: null,
    newsletter_modal_opened: false,
    side_nav_opened: false,
  },
  getters: {
    themes: ({ beet }) => {
      const themeList = Object.values(beet.data.themes)

      const childThemesByParent = themeList.reduce((childMap, theme) => {
        const { parent_theme_id } = theme
        if (!parent_theme_id) return childMap
        const siblings = childMap[parent_theme_id] || []
        return { ...childMap, [parent_theme_id]: [...siblings, theme] }
      }, {})

      return themeList
        .filter(({ parent_theme_id }) => !parent_theme_id)
        .reduce((themeMap, parentTheme) => {
          const { id } = parentTheme

          return {
            ...themeMap,
            [id]: { ...parentTheme, children: childThemesByParent[id] || [] },
          }
        }, {})
    },
    trainingsBySlug: ({ beet }) => {
      const { trainings } = beet.data
      return Object.values(trainings).reduce(
        (slugMap, training) => ({ ...slugMap, [training.slug]: training }),
        {},
      )
    },
  },
  mutations: {
    setImageModal(state, value = null) {
      state.imageModal = value
    },
    setNewsletterModalOpened(state, value = false) {
      state.newsletter_modal_opened = value
    },
    setSideNavOpened(state, value = false) {
      state.side_nav_opened = value
    },
  },
  actions: {
    closeImageModal({ commit }) {
      commit('setImageModal', null)
    },
    closeNewsletterModal({ commit }) {
      commit('setNewsletterModalOpened', false)
    },
    closeSideNav({ commit }) {
      commit('setSideNavOpened', false)
    },
    openNewsletterModal({ commit }) {
      commit('setNewsletterModalOpened', true)
    },
    openSideNav({ commit }) {
      commit('setSideNavOpened', true)
    },
  },
})
